import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

export const shopifyApiDefinitions = prefixApi(
  "/shopify",
  apiBuilder({
    alias: "connectShop",
    method: "post",
    path: "/connect",
    parameters: [
      {
        name: "shop",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 204,
    response: z.void(),
  }).build(),
);
